export const defaultNotificationSettings = [
  {
    identifier: 'new-followers',
    displayName: 'New Followers',
    push: true,
    email: true,
  },
  {
    identifier: 'new-upspace-accept',
    displayName: 'Accepted In Group',
    push: true,
    email: true,
  },
  {
    identifier: 'new-upspace-requests',
    displayName: 'New Group Requests',
    push: true,
    email: true,
  },
  {
    identifier: 'follow-posts',
    displayName: 'Posts By Followed Users',
    push: true,
    email: true,
  },
  {
    identifier: 'friend-posts',
    displayName: 'Posts By Friends',
    push: true,
    email: true,
  },
  {
    identifier: 'upspace-trainer-posts',
    displayName: 'Posts By Group Creator',
    push: true,
    email: true,
  },
  {
    identifier: 'high-fives',
    displayName: 'High Fives',
    push: true,
    email: true,
  },
  {
    identifier: 'post-likes',
    displayName: 'Likes',
    push: false,
    email: false,
  },
  {
    identifier: 'my-post-comments',
    displayName: 'Comments on your posts',
    push: true,
    email: false,
  },
  {
    identifier: 'others-post-comments',
    displayName: 'Comments on Posts you commented on',
    push: true,
    email: false,
  },
  {
    identifier: 'direct-messages',
    displayName: 'Direct Messages',
    push: true,
    email: false,
  },
  {
    identifier: 'upspace-messages',
    displayName: 'Group Messages',
    push: true,
    email: false,
  },
  {
    identifier: 'follow-activities',
    displayName: 'Activities Logged by people you Follow',
    push: true,
    email: false,
  },
  {
    identifier: 'upspace-activities',
    displayName: 'Activities Logged by Group Members',
    push: true,
    email: false,
  },
]
